import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const Plus: IconDef = {
  svg: (
    <G>
      <Path
        d="M20 13.8335V27.1668M13.3334 20.5002H26.6667M36.6667 20.5002C36.6667 29.7049 29.2048 37.1668 20 37.1668C10.7953 37.1668 3.33337 29.7049 3.33337 20.5002C3.33337 11.2954 10.7953 3.8335 20 3.8335C29.2048 3.8335 36.6667 11.2954 36.6667 20.5002Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
      strokeWidth: 2,
      viewBox: '0 0 40 40',
    };
  },
};
